import type { FC, ReactElement, ReactNode } from 'react'

import './styles.scss'

export const RadioGroup: FC<{
  children: ReactNode
  id?: string
  label?: string | ReactElement
  className?: string
}> = ({ label, id, children, className = '' }) => (
  <div className={`radio-group ${className}`} role="radiogroup" aria-labelledby={id}>
    {label && (
      <span className="label mb-2 block" id={id}>
        {label}
      </span>
    )}

    <div className="radio-buttons">{children}</div>
  </div>
)
